var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercard = function SvgMastercard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "#000",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M19.752 6c3.186 0 5.768 2.552 5.768 5.7s-2.582 5.7-5.768 5.7a5.8 5.8 0 0 1-3.741-1.364 5.8 5.8 0 0 1-3.742 1.364c-3.186 0-5.769-2.552-5.769-5.7S9.083 6 12.269 6c1.428 0 2.734.514 3.742 1.363A5.8 5.8 0 0 1 19.752 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M19.753 6c3.186 0 5.768 2.552 5.768 5.7s-2.583 5.7-5.768 5.7a5.8 5.8 0 0 1-3.742-1.364 5.66 5.66 0 0 0 2.026-4.336 5.66 5.66 0 0 0-2.026-4.337A5.8 5.8 0 0 1 19.753 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M16.01 7.363a5.66 5.66 0 0 1 2.027 4.337c0 1.737-.787 3.29-2.027 4.336a5.66 5.66 0 0 1-2.026-4.336 5.66 5.66 0 0 1 2.026-4.337"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export default ForwardRef;